import React, { useEffect, useState } from 'react';
import style from './ApplicationForm.style';
import { Button, ButtonGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faCircleDot,
  faExclamationCircle,
  faPencil,
} from '@fortawesome/free-solid-svg-icons';
import RezRateImg from '../../../../../../../assets/images/header/rezRate.gif';
import VerticalStepper from 'Body/RezRATE/Common/VertifcalStepper/VerticalStepper';
import { clone } from 'Services/schedule';
import ApplicationField from '../../../ApplicationField/ApplicationField';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { postDataAgnostic, putData } from 'Services/dataApi';
import { formatBearerToken } from 'Common.functions';
import { useAlert } from 'react-alert';
import Swal from 'sweetalert2';
import { ApplicationFormFields } from 'enums';

import RezRateSideDrawer from 'Body/RezRATE/Common/RezRateSideDrawer/RezRateSideDrawer';
import { RouterPrompt } from 'Body/RezRATE/Common/RouterPrompt/RouterPrompt';
import RezRateBanner from 'Body/RezRATE/Common/RezRateBanner/RezRateBanner';

const statusIcons = {
  'Not Started': faCircleDot,
  'In Progress': faCircleDot,
  Done: faCheckCircle,
};

const statusColors = {
  'Not Started': '#a6a6a6',
  'In Progress': '#FFA500',
  Done: 'green',
};

const ApplicationForm = (props) => {
  const {
    applicationCode,
    applicationDetails,
    selectedOpening,
    applicantDetails,
    isAdmin,
    isReadOnly,
    isLoading,
    onApply,
    onSave,
    isEdit,
    departmentData,
    setExternalHasUnsavedChanges, // TODO! External, for parent
  } = props;
  const { pk_Applicant } = applicantDetails || {};
  const [currentSection, setCurrentSection] = useState();
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);

  const [isSavingForm, setIsSavingForm] = useState(false);
  const [isOpenSideBar, setIsOpenSideBar] = useState(false);
  const [sections, setSections] = useState([
    {
      label: 'Personal Information',
      fields: [
        { label: 'First Name', dataKey: 'FirstName', required: true },
        { label: 'Middle Name', dataKey: 'MiddleName', required: true },
        { label: 'Last Name', dataKey: 'LastName', required: true },
        { label: 'Preferred Name', dataKey: 'PreferredName' },
        { label: 'Gender', dataKey: 'Gender' },
        { label: 'Date of Birth', dataKey: 'DateOfBirth' },
        { label: 'Medical License Number', dataKey: 'MedicalLicenseNumber' },
        { label: 'Medical License State', dataKey: 'MedicalLicenseState' },
        { label: 'AAMCID', dataKey: 'AAMCID' },
        { label: 'SFMatch ID', dataKey: 'SFMatchID' },
        { label: 'NRMP ID', dataKey: 'NRMPID' },
      ],
    },
    {
      label: 'Contact Information',
      fields: [
        { label: 'Email*', dataKey: 'Email' },
        { label: 'Phone', dataKey: 'Phone' },
        { label: 'Current Cell Phone Number', dataKey: 'CurrentCellPhoneNumber' },
        { label: 'Current Street Address', dataKey: 'CurrentStreetAddress' },
        { label: 'Current City', dataKey: 'CurrentCity' },
        { label: 'Current State', dataKey: 'CurrentState' },
        { label: 'Current Zip', dataKey: 'CurrentZip' },
        { label: 'Current Country', dataKey: 'CurrentCountry' },
      ],
    },
    {
      label: 'Other Demographic Information',
      fields: [
        { label: 'Country of Birth', dataKey: 'CountryOfBirth' },
        { label: 'City of Birth', dataKey: 'CityOfBirth' },
        { label: 'State of Birth', dataKey: 'StateOfBirth' },
        { label: 'Country of Citizenship', dataKey: 'CountryOfCitizenship' },
        { label: 'Is Visa Required', dataKey: 'IsVisaRequired' },
        { label: 'Will Be Paid By Military', dataKey: 'WillBePaidByMilitary' },
        { label: 'Couples Match', dataKey: 'CouplesMatch' },
        { label: 'Couples Partner Specialty', dataKey: 'CouplesPartnerSpecialty' },
        { label: 'Felony Conviction (Y/N)', dataKey: 'FelonyConviction', type: 'switch' },
        { label: 'Felony Conviction Reason (Text)', dataKey: 'FelonyConvictionReason' },
      ],
    },
    {
      label: 'USMLE',
      fields: [
        { label: 'USMLE ID', dataKey: 'USMLEID' },
        { label: 'USMLE Step 1 Score', dataKey: 'USMLEStep1Score' },
        { label: 'USMLE Step 1 Status', dataKey: 'USMLEStep1Status' },
        { label: 'USMLE Step 2 CS Score', dataKey: 'USMLEStep2CSScore' },
        { label: 'USMLE Step 2 CS Date', dataKey: 'USMLEStep2CSDate' },
        { label: 'USMLE Step 3 Score', dataKey: 'USMLEStep3Score' },
        { label: 'USMLE Step 3 Date', dataKey: 'USMLEStep3Date' },
        { label: 'USMLE Completion Date', dataKey: 'USMLECompletionDate' },
      ],
    },
    {
      label: 'ABR Core Exam',
      fields: [
        { label: 'Score Pass Fail ABR Core Exam', dataKey: 'ScorePassFailABRCoreExam' },
        { label: 'Expected Date Of ABR Core Exam Results', dataKey: 'ExpectedDateOfABRCoreExamResults' },
      ],
    },
    {
      label: 'COMLEX USA',
      fields: [
        { label: 'COMELEX USA Level 1 Date', dataKey: 'COMELEXUSALevel1Date' },
        { label: 'COMELEX USA Level 1 Score', dataKey: 'COMELEXUSALevel1Score' },
        { label: 'COMELEX USA Level 2 CE Date', dataKey: 'COMELEXUSALevel2CEDate' },
        { label: 'COMELEX USA Level 2 CE Score', dataKey: 'COMELEXUSALevel2CEScore' },
        { label: 'COMELEX USA Level 2 PE Date', dataKey: 'COMELEXUSALevel2PEDate' },
        { label: 'COMELEX USA Level 2 PE Score', dataKey: 'COMELEXUSALevel2PEScore' },
        { label: 'COMELEX USA Level 3 Date', dataKey: 'COMELEXUSALevel3Date' },
        { label: 'COMELEX USA Level 3 Score', dataKey: 'COMELEXUSALevel3Score' },
      ],
    },
    {
      label: 'Awards',
      fields: [
        { label: 'Alpha Omega Alpha (Y/N)', dataKey: 'AlphaOmegaAlpha' },
        { label: 'Sigma Sigma Phi (Y/N)', dataKey: 'SigmaSigmaPhi' },
        { label: 'Gold Humanism Honor Society (Y/N)', dataKey: 'GoldHumanismHonorSociety' },
        { label: 'Other (Text Field + Ability to add additional line items)', dataKey: 'OtherAwards' },
      ],
    },
    {
      label: 'Education',
      fields: [
        { label: 'Education College Attended', dataKey: 'EducationCollegeAttended' },
        { label: 'Education College Degree', dataKey: 'EducationCollegeDegree' },
        { label: 'Education College Date Of Graduation', dataKey: 'EducationCollegeDateOfGraduation' },
        { label: 'Education Medical School Attended', dataKey: 'EducationMedicalSchoolAttended' },
        { label: 'Education Medical School Degree', dataKey: 'EducationMedicalSchoolDegree' },
        { label: 'Education Medical School Date Of Graduation', dataKey: 'EducationMedicalSchoolDateOfGraduation' },
        { label: 'Education Place Of Internship', dataKey: 'EducationPlaceOfInternship' },
        { label: 'Education Internship Specialty', dataKey: 'EducationInternshipSpecialty' },
        { label: 'Education Internship Start Date', dataKey: 'EducationInternshipStartDate' },
        { label: 'Education Internship End Date', dataKey: 'EducationInternshipEndDate' },
        { label: 'Education Place Of Residency', dataKey: 'EducationPlaceOfResidency' },
        { label: 'Education Residency Specialty', dataKey: 'EducationResidencySpecialty' },
        { label: 'Education Residency Date Start', dataKey: 'EducationResidencyDateStart' },
        { label: 'Education Residency Date End', dataKey: 'EducationResidencyDateEnd' },
        { label: 'Education Place Of Fellowship', dataKey: 'EducationPlaceOfFellowship' },
        { label: 'Education Fellowship Specialty', dataKey: 'EducationFellowshipSpecialty' },
        { label: 'Education Fellowship Date Start', dataKey: 'EducationFellowshipDateStart' },
        { label: 'Education Fellowship Date End', dataKey: 'EducationFellowshipDateEnd' },
        { label: 'Additional Graduate Degree', dataKey: 'AdditionalGraduateDegree' },
        { label: 'Additional Graduate Degree School', dataKey: 'AdditionalGraduateDegreeSchool' },
        { label: 'Additional Graduate Degree Date Start', dataKey: 'AdditionalGraduateDegreeDateStart' },
        { label: 'Additional Graduate Degree Date End', dataKey: 'AdditionalGraduateDegreeDateEnd' },
        { label: 'Medical Training Inturupted (Y/N)', dataKey: 'MedicalTrainingInturupted' },
        { label: 'Explanation Of Medical Training Inturupted', dataKey: 'ExplanationOfMedicalTrainingInturupted' },
      ],
    },
    {
      label: 'Publications',
      fields: [
        {
          label: 'Count Of Non-Peer Reviewed Online Publications',
          dataKey: 'CountOfNonPeerReviewedOnlinePublications',
        },
        {
          label: 'Links To Non-Peer Reviewed Online Publications',
          dataKey: 'LinksToNonPeerReviewedOnlinePublications',
        },
        { label: 'Count Of Oral Presentations', dataKey: 'CountOfOralPresentations' },
        { label: 'Count Of Peer Reviewed Book Chapter', dataKey: 'CountOfPeerReviewedBookChapter' },
        {
          label: 'Count Of Peer Reviewed Journal Articles And/or Abstracts',
          dataKey: 'CountOfPeerReviewedJournalArticlesAndOrAbstracts',
        },
        {
          label: 'Count Of Peer Reviewed Journal Articles And/or Abstracts Other Than Published',
          dataKey: 'CountOfPeerReviewedJournalArticlesAndOrAbstractsOtherThanPublished',
        },
        { label: 'Count Of Peer Reviewed Online Publication', dataKey: 'CountOfPeerReviewedOnlinePublication' },
        { label: 'Links To Peer Reviewed Online Publication', dataKey: 'LinksToPeerReviewedOnlinePublication' },
        { label: 'Count Of Poster Presentation', dataKey: 'CountOfPosterPresentation' },
        { label: 'Count Of Scientific Monograph', dataKey: 'CountOfScientificMonograph' },
        { label: 'Count Of Other Articles', dataKey: 'CountOfOtherArticles' },
      ],
    },
    {
      label: 'Hobbies',
      fields: [
        { label: 'Hobbies (Text)', dataKey: 'Hobbies' },
        { label: 'Other Interests (Text)', dataKey: 'OtherInterests' },
        { label: 'Language Fluency', dataKey: 'LanguageFluency' },
      ],
    },
  ]);
  const [bannerMessage, setBannerMessage] = useState('');
  const [bannerColor, setBannerColor] = useState(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth < window.innerHeight);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const { isAuthenticated, login, getToken } = useKindeAuth();
  const alert = useAlert();

  useEffect(() => {
    // Your code here
    processSectionStatuses();

    const handleResize = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      if (windowWidth < windowHeight && windowWidth < 680) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      setCurrentSection(null);
    };
  }, []);

  useEffect(() => {
    if (currentSection) {
      setCurrentSectionIndex(sections.findIndex((section) => section.label === currentSection.label));

      processSectionStatuses({ forcedSections: sections });
    }
  }, [currentSection]);

  useEffect(() => {
    // console.log('sections change: ', sections);
  }, [sections]);

  useEffect(() => {
    if (
      (applicationCode && !applicationDetails) ||
      (applicationDetails && Object.keys(applicationDetails).length <= 0)
    ) {
      // verifyCode(applicationCode);
    }
  }, [applicationCode]);

  useEffect(() => {
    // THIS IS CORRECT - applicationDetails SHOULD be the submitted form, applicantDetails is the base Application form. IF no submitted form, assume this is a new application and populate sections using base form.
    initializeSections(applicationDetails ? applicationDetails : applicantDetails);
  }, [applicantDetails, applicationDetails]);

  useEffect(() => {
    if (setExternalHasUnsavedChanges) {
      setExternalHasUnsavedChanges(hasUnsavedChanges);
    }
  }, [hasUnsavedChanges]);

  const verifyCode = async (codeToVerify) => {
    const token = await getToken();

    //  For testing, creating app code for Matt's dept.
    postDataAgnostic('applicant/code/verify', null, { code: codeToVerify }, formatBearerToken(token))
      .then((result) => {
        if (result.data && result.data.message && result.data.message === 'Invalid Code') {
          // Invalid Code message. It always throws though, so we never reach here
        } else {
          // history.push(`/applicant/applicant_profile/new_application?applicationCode=${code}`);
        }
      })
      .catch((err) => {
        // setIsValidatingCode(false);
        console.log('err: ', err);
      });
  };

  const handleChange = (data) => {
    const { e, field, fieldIndex } = data;
    const { type, dataKey } = field;
    const { target } = e;

    const initialValue = applicantDetails[dataKey] || '';
    const newSections = sections;
    const currentSectionIndex = newSections.findIndex((section) => section.label === currentSection.label);
    const newSection = newSections[currentSectionIndex];
    const newField = clone(newSection.fields[fieldIndex]);

    switch (type) {
      case 'switch':
        newField.value = target.checked;
        break;
      default:
        newField.value = target.value;
        break;
    }
    newSection.fields[fieldIndex] = newField;
    newSections[currentSectionIndex] = newSection;

    processSectionStatuses({
      forcedSections: newSections,
      callback: (newData) => {
        const { newSections } = newData;
        setSections(newSections);
        setCurrentSection(newSections[currentSectionIndex]);

        if (initialValue !== newField.value) {
          setHasUnsavedChanges(true);
        } else {
          checkForUnsavedChanges(newSections);
        }
      },
    });
  };

  const checkForUnsavedChanges = (sectionsToCheck) => {
    const initialSetup = applicationDetails ? applicationDetails : applicantDetails;
    let newHasUnsavedChanges = false;

    sectionsToCheck.forEach((section) => {
      const { fields = [] } = section;
      fields.forEach((field) => {
        const { value, dataKey } = field;
        const initialValue = initialSetup[dataKey] || '';

        if (initialValue && initialValue !== value) {
          newHasUnsavedChanges = true;
          return;
        }
      });
    });

    setHasUnsavedChanges(newHasUnsavedChanges);
  };

  const processSectionStatuses = (options) => {
    const { callback, forcedSections } = options || {};
    const newSections = clone(forcedSections) || clone(sections);

    newSections.forEach((section, i) => {
      const { status, label, fields = [] } = section;
      const isCurrentSection = currentSection ? currentSection.label === label : false;

      let hasNonEmptyField = false; // for In Progress
      let allRequiredHasContent = true; // for Done(?)
      let allNonRequiredFieldHasContent = true;
      let newStatus = status;

      fields.forEach((field) => {
        const { value, required, label } = field;

        if (field.value) {
          hasNonEmptyField = true;
        } else {
          if (required) {
            allRequiredHasContent = false;
          } else {
            allNonRequiredFieldHasContent = false;
          }
        }
      });

      if (allRequiredHasContent && allNonRequiredFieldHasContent) {
        newStatus = 'Done';
      } else if (hasNonEmptyField) {
        newStatus = 'In Progress';
      }

      section.icon = (
        <FontAwesomeIcon
          icon={statusIcons[newStatus]}
          style={{ color: statusColors[newStatus], fontSize: isCurrentSection ? 39 : 24 }}
        />
      );

      if (!newStatus) {
        section.status = 'Not Started';
      } else {
        section.status = newStatus;
      }
    });

    if (callback) {
      callback({
        newCurrentSection: newSections[0],
        newSections,
      });
    } else {
      if (!currentSection) {
        setCurrentSection(newSections[0]);
      }

      setSections(newSections);
    }
  };

  const initializeSections = (data = {}) => {
    const newSections = clone(sections);

    newSections.forEach((section) => {
      const { fields = [] } = section;
      let hasValue = false;
      let hasAllValues = true;
      fields.forEach((field) => {
        const { dataKey } = field;
        const newValue = data[dataKey] || '';
        field.value = newValue;

        if (newValue) {
          hasValue = true;
        } else {
          hasAllValues = false;
        }
      });
      section.status = hasAllValues ? 'Done' : hasValue ? 'In Progress' : 'Not Started';
    });

    processSectionStatuses({
      forcedSections: newSections,
      callback: (newData) => {
        const { newCurrentSection, newSections } = newData;
        setSections(newSections);
        if (!currentSection) {
          setCurrentSection(() => {
            return newSections[0];
          });
        }

        setHasUnsavedChanges(false);
      },
    });
  };

  const saveForm = async ({ submit = false, doOnApply = false, doSilently = false, doOnSave = false }) => {
    const dataToSubmit = {};
    const sectionsWithMissingRequiredFields = [];

    sections.forEach((section) => {
      const { label, fields } = section;
      fields.forEach((field) => {
        const { required, dataKey, value } = field;

        if (submit && required && !value) {
          if (!sectionsWithMissingRequiredFields.includes(label)) {
            sectionsWithMissingRequiredFields.push(label);
          }
        }

        dataToSubmit[dataKey] = value || '';
        if (typeof dataToSubmit[dataKey] === 'string') {
          dataToSubmit[dataKey] = dataToSubmit[dataKey].trim();
        }
      });
    });

    if (sectionsWithMissingRequiredFields.length > 0) {
      if (!doSilently && !isMobile) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          html: `Please fill out all required fields in the following sections:<br>${sectionsWithMissingRequiredFields
            .map((section) => `<br>${section}`)
            .join('')}`,
        });
      } else {
        setBannerColor('#e81300');
        setBannerMessage(
          `Please fill out all required fields in the following sections: ${sectionsWithMissingRequiredFields.join(
            ', ',
          )}`,
        );
      }
      return;
    }

    const { fk_Department, fk_Season, fk_ApplicationOpening, pk_ApplicationRecord } =
      applicationDetails || departmentData;
    const token = await getToken();
    setIsSavingForm(true);
    let promiseToCall;
    if (doSilently) {
      setBannerMessage('Autosaving form. . .');
    } else if (submit) {
      setBannerMessage('Saving and Submitting form. . .');
    } else {
      setBannerMessage('Saving form. . .');
    }

    setBannerColor('#e9ecef');
    if (isEdit) {
      promiseToCall = putData(
        'applicant/application/submission',
        { pk_ApplicationRecord: pk_ApplicationRecord },
        { ...dataToSubmit },
        formatBearerToken(token),
      );
    } else {
      promiseToCall = postDataAgnostic(
        'applicant/application',
        {
          pk_Applicant: applicantDetails.pk_Applicant,
          pk_Department: fk_Department,
          pk_Season: fk_Season,
          pk_ApplicationOpening: fk_ApplicationOpening,
        },
        { ...dataToSubmit },
        formatBearerToken(token),
      );
    }

    promiseToCall
      .then((result1) => {
        if (!doSilently && !isMobile) {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Form saved successfully',
            timer: 3000,
            timerProgressBar: true,
          });
        }

        if (!submit) {
          setBannerMessage('Form saved successfully');
          setBannerColor('#38d662');
        }

        // alert.success('Form saved successfully');
        setIsSavingForm(false);

        if (submit) {
          putData(
            'applicant/application',
            { pk_ApplicationRecord: pk_ApplicationRecord },
            {
              IsSubmitted: true,
            },
            formatBearerToken(token),
          )
            .then((result2) => {
              if (!doSilently && !isMobile) {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Form submitted successfully',
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
              // if (window.innerWidth <= 1000) {
              // alert.success('Form saved successfully');
              // setBannerMessage(' ');
              // } else if (doSilently)
              else {
                setBannerMessage('Form submitted successfully');
                setBannerColor('#38d662');
              }
              if (onApply && doOnApply) {
                onApply();
              }
              if (onSave && doOnSave) {
                onSave();
              }

              setHasUnsavedChanges(false);
              setExternalHasUnsavedChanges(false);
            })
            .catch((e) => {
              if (!doSilently && !isMobile) {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Form failed to submit',
                });
              }
              //   if (window.innerWidth <= 1000) {
              //   alert.error('Form failed to save');
              // } else if (doSilently)
              else {
                setBannerColor('#e81300');
                setBannerMessage('Form failed to submit');
              }
            });
        } else {
          setHasUnsavedChanges(false);
          setExternalHasUnsavedChanges(false);
          if (onApply && doOnApply) {
            onApply();
          }

          if (onSave && doOnSave) {
            onSave();
          }
        }
      })
      .catch((err) => {
        setIsSavingForm(false);
        if (!doSilently && !isMobile) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Form failed to save',
          });
        }
        //   if (window.innerWidth <= 1000) {
        //   alert.error('Form failed to save');
        // } else if (doSilently)
        else if (!submit) {
          setBannerColor('#e81300');
          setBannerMessage('Form failed to save');
        }

        // alert.error('Form failed to save');
        console.log(' saveForm err: ', err);
      });

    // applicant/application
  };

  const renderSideNavBar = () => {
    const { DepartmentName, DepartmentLogo } = departmentData || {};
    if (isMobile) {
      return (
        <RezRateSideDrawer
          isOpen={isOpenSideBar}
          setIsOpen={setIsOpenSideBar}
          toggle={() => {
            setIsOpenSideBar(!isOpenSideBar);
          }}
        >
          <VerticalStepper
            isMobile={isMobile}
            sections={sections}
            setCurrentSection={setCurrentSection}
            currentSection={currentSection}
            DepartmentLogo={DepartmentLogo}
            onSelect={() => {
              setIsOpenSideBar(false);
              if (hasUnsavedChanges && !isReadOnly && isEdit) {
                saveForm({ doOnApply: false, doSilently: true, doOnSave: true });
              }
            }}
          />
        </RezRateSideDrawer>
      );
    } else {
      return (
        <VerticalStepper
          sections={sections}
          setCurrentSection={setCurrentSection}
          currentSection={currentSection}
          DepartmentLogo={DepartmentLogo}
          onSelect={() => {
            if (hasUnsavedChanges && !isReadOnly && isEdit) {
              saveForm({ doOnApply: false, doSilently: true, doOnSave: true });
            }
          }}
        />
      );
    }
  };

  const renderFormForSection = () => {
    if (!currentSection) {
      return;
    }
    const sectionToDisplay = sections[currentSectionIndex];
    const { status, label } = sectionToDisplay;
    const color = statusColors[status];
    const icon = statusIcons[status];
    const { Department = {}, IsSubmitted, IsUnderReview, IsRejected } = applicationDetails || {};
    const { DepartmentName, DepartmentLogo } = Department;

    return (
      <div style={{ ...style.simpleColumn, width: '100%' }}>
        <RezRateBanner message={bannerMessage} backgroundColor={bannerColor} />
        <div
          style={{
            ...style.simpleRow,
            width: '100%',
            marginLeft: 20,
            marginBottom: 10,
            justifyContent: 'space-between',
          }}
        >
          <div style={{ ...style.simpleColumn, width: 250 }}>
            <div style={{ ...style.simpleRow, width: '100%' }}>
              <div style={style.simpleColumn}>
                <div
                  style={{
                    ...style.simpleRow,
                    width: '100%',
                    justifyContent: 'left',
                    paddingLeft: 5,
                    fontSize: 20,
                    fontWeight: 'bold',
                  }}
                >
                  {label}
                </div>
              </div>
            </div>
          </div>
          {isAdmin ? null : (
            <div style={{ ...style.simpleColumn, width: 180, color: color, fontWeight: 'bold', fontSize: 18 }}>
              <div style={{ ...style.simpleRow, width: '100%' }}>
                <FontAwesomeIcon icon={icon} style={{ color: color, marginRight: 10, fontSize: 15 }} />
                {status}
              </div>
            </div>
          )}
        </div>

        <div
          style={{
            ...style.simpleRow,
            height: 'calc(100vh - 340px)',
            overflowY: 'auto',
            width: '100%',
            alignItems: 'flex-start',
            marginTop: 10,
          }}
        >
          <div style={style.simpleColumn}>
            {sectionToDisplay.fields.map((field, i) => {
              const { dataKey, label, required, value } = field;
              const fieldId = `${sectionToDisplay.label}-${dataKey}`;
              const type = ApplicationFormFields[dataKey] || 'text';
              return (
                <ApplicationField
                  isMobile={isMobile}
                  key={fieldId}
                  fieldId={fieldId}
                  field={field}
                  type={type}
                  label={label}
                  required={required}
                  value={value}
                  disabled={isReadOnly || isLoading || isSavingForm}
                  onChange={(e) => {
                    handleChange({
                      e: e,
                      field: field,
                      fieldIndex: i,
                    });
                  }}
                />
              );
            })}
          </div>
        </div>

        <div
          style={{
            ...style.simpleRow,
            width: '100%',
            justifyContent: isMobile ? 'center ' : 'space-between',
            marginTop: 10,
          }}
        >
          {isMobile || true ? (
            <ButtonGroup style={{ width: '100%' }}>
              <Button
                disabled={currentSectionIndex <= 0 || isSavingForm}
                size="sm"
                color="primary"
                style={{ width: '25%' }}
                onClick={() => {
                  if (hasUnsavedChanges && !isReadOnly && isEdit) {
                    saveForm({ doOnApply: false, doSilently: true, doOnSave: true });
                  }
                  setCurrentSection(sections[currentSectionIndex - 1]);
                }}
              >
                <div style={style.simpleRow}>
                  <FontAwesomeIcon icon={faChevronCircleLeft} style={{ marginRight: 10 }} />
                  Previous{' '}
                </div>
              </Button>
              {isReadOnly ||
              (applicationDetails && (applicationDetails.IsImported || applicationDetails.IsRejected)) ? null : (
                <>
                  <Button
                    size="sm"
                    color="primary"
                    disabled={isSavingForm || !hasUnsavedChanges || isReadOnly || isLoading}
                    style={{ width: '25%', fontWeight: 'normal' }}
                    onClick={() => {
                      saveForm({ doOnSave: true });
                    }}
                  >
                    Save
                  </Button>
                  <Button
                    size="sm"
                    color="success"
                    disabled={isSavingForm || isReadOnly || isLoading}
                    style={{ width: '25%', fontWeight: 'normal' }}
                    onClick={() => {
                      Swal.fire({
                        title: 'Save and Submit?',
                        text: 'Applications that are submitted cannot be unsubmitted.',
                        icon: 'warning',
                        showCancelButton: true,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          saveForm({ submit: true, doOnSave: true, doOnApply: true });
                        }
                      });
                    }}
                  >
                    Submit
                  </Button>
                </>
              )}
              <Button
                disabled={currentSectionIndex >= sections.length - 1 || isSavingForm}
                size="sm"
                color="primary"
                style={{ width: '25%' }}
                onClick={() => {
                  if (hasUnsavedChanges && !isReadOnly && isEdit) {
                    saveForm({ doOnApply: false, doSilently: true, doOnSave: true });
                  }
                  setCurrentSection(sections[currentSectionIndex + 1]);
                }}
              >
                <div style={style.simpleRow}>
                  Next <FontAwesomeIcon icon={faChevronCircleRight} style={{ marginLeft: 10 }} />
                </div>
              </Button>
            </ButtonGroup>
          ) : (
            <>
              <Button
                disabled={currentSectionIndex <= 0 || isSavingForm}
                size="sm"
                color="primary"
                style={{ width: isMobile ? 'auto' : 150 }}
                onClick={() => {
                  setCurrentSection(sections[currentSectionIndex - 1]);
                }}
              >
                <div style={style.simpleRow}>
                  <FontAwesomeIcon icon={faChevronCircleLeft} style={{ marginRight: 10 }} />
                  Previous{' '}
                </div>
              </Button>
              {isReadOnly || (applicationDetails && applicationDetails.IsSubmitted) ? null : (
                <>
                  <Button
                    size="sm"
                    color="primary"
                    disabled={isSavingForm}
                    style={{ width: isMobile ? 'auto' : 150, fontWeight: 'normal' }}
                    onClick={() => {
                      saveForm({});
                    }}
                  >
                    Save
                  </Button>
                  <Button
                    size="sm"
                    color="success"
                    disabled={isSavingForm}
                    style={{ width: isMobile ? 'auto' : 150, fontWeight: 'normal' }}
                    onClick={() => {
                      Swal.fire({
                        title: 'Save and Submit?',
                        text: 'Applications that are submitted cannot be edited.',
                        icon: 'warning',
                        showCancelButton: true,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          saveForm({ submit: true });
                        }
                      });
                    }}
                  >
                    Submit
                  </Button>
                </>
              )}
              <Button
                disabled={currentSectionIndex >= sections.length - 1 || isSavingForm}
                size="sm"
                color="primary"
                style={{ width: isMobile ? 'auto' : 150 }}
                onClick={() => {
                  setCurrentSection(sections[currentSectionIndex + 1]);
                }}
              >
                <div style={style.simpleRow}>
                  Next <FontAwesomeIcon icon={faChevronCircleRight} style={{ marginLeft: 10 }} />
                </div>
              </Button>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ ...style.simpleRow, width: '100%', alignItems: 'flex-start' }}>
      {renderSideNavBar()} {renderFormForSection()}
      <RouterPrompt
        hasChanges={hasUnsavedChanges}
        okLabel={'Discard Changes'}
        onOk={() => {
          setHasUnsavedChanges(false);

          return true;
        }}
      />
    </div>
  );
};

export default ApplicationForm;
